module.exports = __webpack_public_path__ + "static/media/aboutImage.9400618a.jpeg";